var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfSettingsImageUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 60C61.9375 60 64 57.8125 64 55V25C64 22.2917 61.9375 20 59.5 20H20.5C17.9688 20 16 22.2917 16 25V55C16 57.8125 17.9688 60 20.5 60H59.5ZM26.5 25.8333C29.3125 25.8333 31.75 28.5417 31.75 31.6667C31.75 34.8958 29.3125 37.5 26.5 37.5C23.5938 37.5 21.25 34.8958 21.25 31.6667C21.25 28.5417 23.5938 25.8333 26.5 25.8333ZM22 53.3333V48.3333L28.6562 40.9375C29.125 40.4167 29.7812 40.4167 30.25 40.9375L35.5 46.6667L48.1562 32.6042C48.625 32.0833 49.2812 32.0833 49.75 32.6042L58 41.6667V53.3333H22Z",
    fill: "black",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 7.5,
    stroke: "#CCCCCC",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfSettingsImageUpload);
export default __webpack_public_path__ + "static/media/BFSettings-ImageUpload.ee36238ba85ffa519f3a6fcb093d56b4.svg";
export { ForwardRef as ReactComponent };